export default class Medication {
  id!: string;
  code: string;
  cvxCode: string;
  ndcCode: string;
  name: string;
  manufacturer: string;
  mvxCode: string;
  dosage: string;
  guideline: string;
  ordering: any;
  isActive: boolean;

  constructor(
    code = "",
    cvxCode = "",
    ndcCode = "",
    name = "",
    manufacturer = "",
    mvxCode = "",
    dosage = "",
    guideline = "",
    ordering = "",
    isActive = true
  ) {
    this.code = code;
    this.cvxCode = cvxCode;
    this.ndcCode = ndcCode;
    this.name = name;
    this.manufacturer = manufacturer;
    this.mvxCode = mvxCode;
    this.dosage = dosage;
    this.guideline = guideline;
    this.ordering = ordering;
    this.isActive = isActive;
  }
}

export type MedicationStatus = {
  id: string;
  isActive: boolean;
};
